<div class='experience-ai-advisor-prompt-responses-view-part'>
	<grid-content [setup]="setup" [namedSize]="'TabContent'" [pageTabsGridSize]="pageTabsGridSize()"
		[rows]="aiPromptsAndResponses()"></grid-content>
</div>